// import * as FileSystem from '../../../expo-file-system'
// import getFullUriFileSystemUtil from '../get-full-uri'
import { logUtil } from 'packages/src'
import existsFileSystemUtil from '../exists'

async function deleteFileSystemUtil (uri) {
  try {
    const itemExists = await existsFileSystemUtil(uri)
    if (!itemExists) {
      return true
    }
    // const fullUri = getFullUriFileSystemUtil(uri)
    // logUtil('').info(`deleting item with fullUri ${fullUri}`)
    // await FileSystem.deleteAsync(fullUri)
    // logUtil('').info(`deleting item with fullUri ${fullUri} succeeded`)
    return true
  } catch (error) {
    logUtil('').info(`deleting item with uri ${uri} failed: `, error)
  }
}

export default deleteFileSystemUtil
